import { AnyAction } from 'redux'
import type { State } from 'shared/types/gallery/state'

const initialState: State.TaxonomyIdByCategoryIdState = {}

export function reducer(state: State.TaxonomyIdByCategoryIdState = initialState, action: AnyAction): State.TaxonomyIdByCategoryIdState {
  switch (action.type) {
    default:
      return state
  }
}
